import React, { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Grid,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { ContactDeactivate, ContactDeactivationVerifyOtp } from '../../../Utils/apiService';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import routes from '../../../Utils/routes';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

interface DynamicDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onSave: () => void;
  fields: Fields[];
  cancelButtonText: string;
  saveButtonText: string;
  otp?: boolean;
  setChecked?: (checked: boolean) => void;
  checked?: boolean;
  handleCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  formData?: any;
}

export interface Fields {
  label: string;
  value: string | null;
  type: 'text' | 'dropdown';
  options?: string[];
  name?: string;
  fieldName?: string;
}

const pincoderegex = /^[0-9]+$/;

const DynamicDialog: React.FC<DynamicDialogProps> = ({
  open,
  title,
  onClose,
  onSave,
  fields,
  cancelButtonText,
  saveButtonText,
  otp, // Receive OTP prop
  setChecked,
  checked,
  handleCheckboxChange,
  formData,
}) => {
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const {
    dispatch,
  } = useContext(AuthContext);
  const [otpValues, setOtpValues] = React.useState(['', '', '', '']);
  console.log(title,"titletitletitletitle");
  
  const [linkedInerrorMessage, setLinkedInErrorMessage] = useState<string>('');
  const [facebookerrorMessage, setFacebookErrorMessage] = useState<string>('');
  const [twittererrorMessage, setTwitterErrorMessage] = useState<string>('');
  const [pincodeValue, setPincodeValue] = useState<string>('');
  const [streetCurAddress, setStreetCurAddress] = useState<string>('');
  const [streetPermtAddress, setStreetPermtAddress] = useState<string>('');
  const [reason, setReason] = useState<string>('');
  const [other, setOther] = useState<string>('');
  const navigate = useNavigate();
  const handleChanges = (index: number, event: any) => {
    const selectedValue = event.target.value;
    setReason(selectedValue);

    // If "Other" is selected, reset `other` state and show the text area
    if (selectedValue !== "Other") {
      setOther(""); // Reset `other` if another option is selected
    }
  };
  const [otpValue, setOtpValue] = useState<string>('');
  const [addressField, setAddressField] = useState([]);
  const [verify, setverify] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleChangeOtp = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      setOtpValue(value);
    }
  };
  console.log('fields', fields);

  const handleVerify = () => {
    if (title === "Delete Account") {
      ContactDeactivationVerifyOtp(userData?.applicantId, otpValue)
        .then((res) => {
          if (res?.errorMessage === "OTP expired" ) {
            enqueueSnackbar({ message: 'OTP expired', variant: 'error', autoHideDuration: 1000 });
            setverify(false);
          }
          else if (res?.errorMessage === "Invalid OTP") {
            enqueueSnackbar({ message: 'Invalid OTP', variant: 'error', autoHideDuration: 1000 });
            setverify(true);
          }
          else if (res?.message === "Otp Verified Successfully.") {
            enqueueSnackbar({ message: 'Otp Verified Successfully.', variant: 'success', autoHideDuration: 1000 });
            setverify(true);
          } else {
            setverify(true);
          }
        })
        .catch((error) => {
          console.error("Error verifying OTP:", error);
          setverify(false);
        });
    }
  };

  const deleteAccount = () => {
    if (title === "Delete Account") {
      const payload: any = {
        contactId: userData?.applicantId,
        reason: reason ? reason : "User requested deactivation",
        other: other ? other : "",
      };
      ContactDeactivate(payload)
        .then((res) => {
          if (res?.success == true) {
            // alert("Account deleted successfully");
            localStorage.clear();
            sessionStorage.clear();
            dispatch({ type: 'LOGOUT' });

          } else {
            alert("Error deleting account");
          }
        }
        )
    }
    else {
      onSave();
    }

  }

  const handleChange = (index: number, event: React.ChangeEvent<HTMLInputElement | { name?: string | undefined; value: unknown }>) => {
    let value: string;

    if ('value' in event.target) {
      value = (event.target as HTMLInputElement).value;
    } else {
      value = (event as React.ChangeEvent<{ value: unknown }>).target.value as string;
    }

    const updatedFields = [...fields];

    updatedFields[index].value = value as string;
    const linkedinRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+\/?$/;
    const facebookRegex = /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?$/;
    const twitterRegex = /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+\/?$/;

    // Validate the URL based on the field name
    if (updatedFields[index].name === 'linkedinURL') {
      if (!value) {
        setLinkedInErrorMessage('');
      } else if (linkedinRegex.test(value)) {
        setLinkedInErrorMessage('');
      } else {
        setLinkedInErrorMessage('Invalid LinkedIn URL');
      }
    } else if (updatedFields[index].name === 'facebookURL') {
      if (!value) {
        setFacebookErrorMessage('');
      } else if (facebookRegex.test(value)) {
        setFacebookErrorMessage('');
      } else {
        setFacebookErrorMessage('Invalid Facebook URL');
      }
    } else if (updatedFields[index].name === 'twitterURL') {
      if (!value) {
        setTwitterErrorMessage('');
      } else if (twitterRegex.test(value)) {
        setTwitterErrorMessage('');
      } else {
        setTwitterErrorMessage('Invalid Twitter URL');
      }
    } else if (updatedFields[index].name === 'street_ca') {
      console.log('value232', value);
      if (value.length >= 100) {
        setStreetCurAddress('Value must be less than 100 characters');
      } else {
        setStreetCurAddress('');
      }
    } else if (updatedFields[index].name === 'street_pa') {
      if (value.length >= 100) {
        setStreetPermtAddress('Value must be less than 100 characters');
      } else {
        setStreetPermtAddress('');
      }
    } else if (updatedFields[index].name === 'pinCode_ca' || updatedFields[index].name === 'pinCode_pa') {
      if (value.length > 6) {
        setPincodeValue('Value must be less than 6 numbers');
      } else if (!pincoderegex.test(value)) {
        setPincodeValue('Invalid pincode');
      } else {
        setPincodeValue('');
      }
    } else {
      setPincodeValue('');
      setLinkedInErrorMessage('');
      setFacebookErrorMessage('');
      setTwitterErrorMessage('');
      setStreetPermtAddress('');
      setStreetCurAddress('');
    }

    setAddressField(updatedFields as any);
  };

  console.log('checked324', checked ? formData?.flatNo_pa : formData?.flatNo_ca);
  const currentAddressFields: any = [
    { label: 'House/flat no', name: 'flatNo_ca', value: checked ? formData?.flatNo_pa : formData?.flatNo_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'Street', name: 'street_ca', value: checked ? formData?.street_pa : formData?.street_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'Suburb', name: 'suburb_ca', value: checked ? formData?.suburb_pa : formData?.suburb_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'City', name: 'city_ca', value: checked ? formData?.city_pa : formData?.city_ca, type: 'text', fieldName: 'Current Address' },
    { label: 'Pincode', name: 'pinCode_ca', value: checked ? formData?.pinCode_pa : formData?.pinCode_ca, type: 'text', fieldName: 'Current Address' },
  ];
  useEffect(() => {
    setLoading(true);
    setAddressField(currentAddressFields);
    setLoading(false);
  }, [checked, formData, loading]);
  console.log('addressField21', addressField, loading, formData);

  return (
    <Dialog open={open} onClose={(_, reason) => { if (reason !== 'backdropClick') { onClose(); setOtpValue(''); } }} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={{ fontSize: '15px', fontWeight: '500' }}>{title}</Typography>
        {title === 'Current Address' && (
          <FormControlLabel
            control={<Checkbox size="small" checked={checked} onChange={handleCheckboxChange} />}
            label={<Typography sx={{ fontSize: 12 }}>Same as permanent Address</Typography>}
          // onClick={() => {
          //   setLoading(true);
          // }}
          />
        )}
        <IconButton edge="end" color="inherit" onClick={()=>{onClose();setOtpValue('')}}  aria-label="close" style={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {title == 'Current Address' ? (
          <>
            {loading == true ? (
              <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {addressField.map((field: any, index: any) => (
                  <div key={index} style={{ marginBottom: '16px' }}>
                    <div style={{ fontSize: '12px', fontWeight: 500 }}>{field.label}</div>
                    {field.type === 'text' ? (
                      <TextField name={field.name} value={field.value} onChange={(e) => handleChange(index, e)} margin="normal" fullWidth size="small" />
                    ) : field.type === 'dropdown' ? (
                      <Select
                        value={field.value}
                        onChange={(e) => handleChange(index, e as any)}
                        fullWidth
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#3061FF',
                          },
                        }}
                      >
                        {field.options?.map((option: any, optionIndex: any) => (
                          <MenuItem
                            key={optionIndex}
                            value={option}
                            sx={{
                              '&.Mui-selected': {
                                backgroundColor: 'transparent',
                              },
                              '&.Mui-selected:hover': {
                                backgroundColor: 'transparent',
                              },
                              '&:hover': {
                                backgroundColor: 'transparent',
                              },
                              '&:active': {
                                backgroundColor: 'transparent',
                              },
                            }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    ) : null}
                    <div style={{ color: 'red' }}>
                      {field.name === 'linkedinURL'
                        ? linkedInerrorMessage
                        : field.name === 'facebookURL'
                          ? facebookerrorMessage
                          : field.name === 'twitterURL'
                            ? twittererrorMessage
                            : field.name == 'street_ca'
                              ? streetCurAddress
                              : field.name == 'street_pa'
                                ? streetPermtAddress
                                : field.name == 'pinCode_ca' || field.name == 'pinCode_pa'
                                  ? pincodeValue
                                  : ''}
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        ) : (
          <>
            {fields.map((field, index) => (
              <div key={index} style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '12px', fontWeight: 500 }}>{field.label}</div>
                {field.type === 'text' ? (
                  <TextField name={field.name} defaultValue={field.value} onChange={(e) => handleChange(index, e)} margin="normal" fullWidth size="small" />
                ) : field.type === 'dropdown' ? (
                  <>
                    <Select
                      value={reason}
                      onChange={(e) => handleChanges(index, e as any)}
                      defaultValue={reason}
                      fullWidth
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3061FF',
                        },
                      }}
                    >
                      {field.options?.map((option, optionIndex) => (
                        <MenuItem
                          key={optionIndex}
                          value={option}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'transparent',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:active': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                    {reason === "Other" && (
                      <TextField
                        placeholder="Please specify your reason"
                        value={other}
                        onChange={(e) => setOther(e.target.value)}
                        margin="normal"
                        fullWidth
                        size="small"
                      />
                    )}
                  </>


                ) : null}
                <div style={{ color: 'red' }}>
                  {field.name === 'linkedinURL'
                    ? linkedInerrorMessage
                    : field.name === 'facebookURL'
                      ? facebookerrorMessage
                      : field.name === 'twitterURL'
                        ? twittererrorMessage
                        : field.name == 'street_ca'
                          ? streetCurAddress
                          : field.name == 'street_pa'
                            ? streetPermtAddress
                            : field.name == 'pinCode_ca' || field.name == 'pinCode_pa'
                              ? pincodeValue
                              : ''}
                </div>
              </div>
            ))}
          </>
        )}

        {otp && (
          <>
            <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>An OTP has been sent to the registered email</Typography>
            <Box display="flex" justifyContent="center" alignItems="center">
              <TextField
                id="otp"
                value={otpValue}
                onChange={handleChangeOtp}
                inputProps={{
                  maxLength: 4,
                  style: { textAlign: 'left', letterSpacing: '10px' },
                }}
                placeholder="----"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography onClick={handleVerify} sx={{ color: '#3061FF', fontSize: '10.5px', fontWeight: 500, textDecoration: 'underline' ,cursor: 'pointer'}}>
                        Verify
                      </Typography>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Grid container sx={{ px: 4 }} justifyContent="space-between">
          <Grid item md={6} textAlign={'center'}>
            <Button
              onClick={()=>{onClose();setOtpValue('');}}
              sx={{
                width: '100%',
                background: '#EAEFFF',
                p: 2,
                height: '36px',
              }}
            >
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{cancelButtonText}</Typography>
            </Button>
          </Grid>
          {title === "Delete Account" ?
            <Grid item md={6} textAlign={'center'}>
              <Button
                onClick={() => { deleteAccount(); onClose(); }}
                variant="contained"
                sx={{
                  background: 'linear-gradient(90deg,#00387A,#006BB7)',
                  width: '100%',
                  p: 2,
                  ml: 2,
                  height: '36px',
                }}
                disabled={!verify}
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{saveButtonText}</Typography>
              </Button>
            </Grid>
            :
            <Grid item md={6} textAlign={'center'}>
              <Button
                onClick={deleteAccount}
                variant="contained"
                sx={{
                  background: 'linear-gradient(90deg,#00387A,#006BB7)',
                  width: '100%',
                  p: 2,
                  ml: 2,
                  height: '36px',
                }}
                disabled={!!facebookerrorMessage || !!twittererrorMessage || !!linkedInerrorMessage || !!pincodeValue}
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{saveButtonText}</Typography>
              </Button>
            </Grid>
          }
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default DynamicDialog;

